var _circle, _circle2, _g, _g2, _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle3, _circle4, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_334)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 95,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 96,
    height: 22,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 33,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 47H49.5L51 52H48L46.5 47Z",
    fill: "#DCAF7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 47H30.5L29 52H32L33.5 47Z",
    fill: "#DCAF7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6665 42C48.6665 43.1047 47.7712 44 46.6665 44H33.3332C32.2285 44 31.3332 43.1047 31.3332 42V28C33.3332 28 32.2285 28 33.3332 28H46.6665C47.7712 28 46.6665 28 48.6665 28V42Z",
    fill: "#006A53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6665 44H31.3332V39.3333C32.6665 39.3333 31.9305 39.3333 32.6665 39.3333H47.3332C48.0692 39.3333 47.3332 39.3333 48.6665 39.3334V44Z",
    fill: "#3EA48E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35.3333C28.6667 35.3333 28.2987 35.3333 28.6667 35.3333H30.6667C31.0347 35.3333 30.25 35.3333 31.3333 35.3333V44H48.6667V35.3333C49.3333 35.3333 48.9653 35.3333 49.3333 35.3333H51.3333C51.7013 35.3333 51.5 35.3333 52 35.3333V45.3333C52 46.806 50.806 48 49.3333 48H30.6667C29.194 48 28 46.806 28 45.3333V35.3333Z",
    fill: "#008B6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 32,
    width: 34,
    height: 4,
    fill: "#ECEDEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 64,
    width: 32,
    height: 4,
    fill: "#ECEDEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 64,
    width: 6,
    height: 4,
    fill: "#ECEDEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 72,
    width: 6,
    height: 4,
    fill: "#ECEDEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 6,
    height: 4,
    fill: "#ECEDEE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 72,
    width: 40,
    height: 4,
    fill: "#ECEDEE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 20,
    height: 4,
    fill: "#ECEDEE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 40,
    width: 16,
    height: 4,
    fill: "#ECEDEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 66,
    r: 2,
    fill: "#008B6D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 74,
    r: 2,
    fill: "#006A53"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 82,
    r: 2,
    fill: "#000E8D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_334",
    x: 5,
    y: 25,
    width: 110,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_334"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_334",
    x: 5,
    y: 3,
    width: 110,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_334"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_334",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.d366c4d6ea0d356ac1593cfb5c340613.svg";
export { ForwardRef as ReactComponent };